import { render, staticRenderFns } from "./revert-course.vue?vue&type=template&id=71cd4729&scoped=true"
import script from "./revert-course.vue?vue&type=script&lang=js"
export * from "./revert-course.vue?vue&type=script&lang=js"
import style0 from "./revert-course.vue?vue&type=style&index=0&id=71cd4729&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cd4729",
  null
  
)

export default component.exports